import { ReactElement, useState } from 'react';
import { Component as CaretDownIcon } from 'icons/icon-ui--caret-outline.svg';
import { Component as CaretUpIcon } from 'icons/icon-ui--caret-up-outline.svg';
import { LtoQuestion } from '../../models/product.types';
import FAQs from '../shared/FAQs/FAQs';
import styles from './LimitedTimeOffering.module.scss';

type Props = {
  questions?: LtoQuestion[]
}

function LimitedTimeOfferingFAQs({ questions }: Props): ReactElement {
  const [showFAQs, setShowFAQs] = useState(true);

  const toggleShowFAQs = () => setShowFAQs((prev) => !prev);
  const FAQsIcon = showFAQs ? CaretUpIcon : CaretDownIcon;

  return (
    <div className={styles.faq_section}>
      <div
        role="button"
        tabIndex={0}
        onClick={toggleShowFAQs}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleShowFAQs();
          }
        }}
      >
        <div className={styles.dropdown}>
          <h3>FAQs</h3>
          <FAQsIcon width={23} />
        </div>
      </div>
      <hr />
      {showFAQs && questions && (
        <div>
          <FAQs
            questions={questions}
          />
        </div>
      )}
    </div>
  );
}

export default LimitedTimeOfferingFAQs;
